import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { _myInformation, MyInformationItem } from "../../indexDB/data";
import { useAppDispatch } from "../../redux/hook";
import { informationClient } from "../../apolloClient";
import { MY_COMPANY } from "../../graphql/graphql_information/company/query";
import { MyCompanyInfo } from "../../graphql/graphql_information/company/types/MyCompanyInfo";
import { MyCompany } from "../../graphql/graphql_information/company/types/MyCompany";
import { setMyInformation } from "../../redux/information/informationSlice";

const useMyInformation = (synchronize?: boolean) => {
  const dispatch = useAppDispatch();

  const [getInformation, { loading, data }] = useLazyQuery<MyCompanyInfo>(
    MY_COMPANY,
    {
      fetchPolicy: "network-only",
      client: informationClient,
      async onCompleted(data) {
        if (data.myCompanyInfo) {
          await _myInformation.setItem(
            MyInformationItem.MY_INFORMATION,
            data.myCompanyInfo,
          );
          await setData(data.myCompanyInfo);
        }
      },
    },
  );

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const cache = await _myInformation.getItem(
      MyInformationItem.MY_INFORMATION,
    );
    if (cache && !synchronize) {
      setData(cache as unknown as MyCompany);
      return;
    }
    getInformation();
  };

  const setData = async (data: MyCompany) => {
    dispatch(setMyInformation(data));
  };

  return { getInformation, loading, data };
};

export default useMyInformation;
